import React from "react";

const inputClass =
  "text-xs md:text-sm w-full p-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";

export default function SchedulingOptions({
  isScheduled,
  onScheduledChange,
  scheduledDate,
  scheduledTime,
  onDateChange,
  onTimeChange,
}) {
  const minDate = new Date().toISOString().split("T")[0];

  return (
    <div className="border-t border-gray-200 pt-6 mt-6">
      <h4 className="text-base md:text-lg font-bold mb-4 text-gray-800">
        Scheduling Options
      </h4>

      <div className="flex items-center mb-4">
        <input
          type="checkbox"
          id="isScheduled"
          checked={isScheduled}
          onChange={(e) => onScheduledChange(e.target.checked)}
          className="h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded flex-shrink-0"
        />
        <label
          htmlFor="isScheduled"
          className="ml-3 block text-xs md:text-sm font-medium text-gray-700 cursor-pointer">
          Schedule this notification for later
        </label>
      </div>

      {isScheduled && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-50 p-4 rounded-lg">
          <div className="min-w-0">
            <label
              htmlFor="scheduledDate"
              className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
              Scheduled Date *
            </label>
            <input
              id="scheduledDate"
              type="date"
              value={scheduledDate}
              onChange={(e) => onDateChange(e.target.value)}
              min={minDate}
              className={inputClass}
              required={isScheduled}
            />
          </div>
          <div className="min-w-0">
            <label
              htmlFor="scheduledTime"
              className="block text-xs md:text-sm font-semibold text-gray-700 mb-2">
              Scheduled Time *
            </label>
            <input
              id="scheduledTime"
              type="time"
              value={scheduledTime}
              onChange={(e) => onTimeChange(e.target.value)}
              className={inputClass}
              required={isScheduled}
            />
          </div>
        </div>
      )}
    </div>
  );
}
